module.exports = __webpack_public_path__ + "static/media/FD_running.76a6a977.png";